export default "__VITE_ASSET__C$z73BK4__"